/** Тексты окна: Босс повержен. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.boss.title": "Boss defeated!",
  "win.boss.reward": "Reward",
  "win.boss.next": "Next: Wave {n}",
  "win.boss.share": "Share the win",
  "win.boss.story": "Post to story",
  "win.boss.inviteTitle": "Invite a friend",
  "win.boss.inviteNote": "You both get a reward when they clear wave 10.",
  "win.boss.inviteReward": "You both get +{coins} coins when they clear wave {wave}.",
  "win.boss.invite": "Invite a friend",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.boss.title": "Босс повержен!",
  "win.boss.reward": "Награда",
  "win.boss.next": "Дальше: волна {n}",
  "win.boss.share": "Поделиться победой",
  "win.boss.story": "В сторис",
  "win.boss.inviteTitle": "Позови друга",
  "win.boss.inviteNote": "Вам обоим награда, когда он пройдёт 10-ю волну.",
  "win.boss.inviteReward": "Вам обоим по +{coins} монет, когда он пройдёт {wave}-ю волну.",
  "win.boss.invite": "Позвать друга",
};

const uk: Record<Key, string> = {
  "win.boss.title": "Боса розбито!",
  "win.boss.reward": "Нагорода",
  "win.boss.next": "Далі: хвиля {n}",
  "win.boss.share": "Поділитися перемогою",
  "win.boss.story": "У сторіс",
  "win.boss.inviteTitle": "Поклич друга",
  "win.boss.inviteNote": "Вам обом нагорода, коли він пройде 10-ту хвилю.",
  "win.boss.inviteReward": "Вам обом по +{coins} монет, коли він пройде {wave}-ту хвилю.",
  "win.boss.invite": "Покликати друга",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
